// @ts-nocheck
import React from 'react'

import styles from './Subtitle.module.scss'

export const Subtitle = ({ children }) => (
  <h4 className={styles.subtitle}>{children}</h4>
)
